import React, { useState } from 'react';
import { WrappedButton, WrappedButtonType } from './button';

interface CopyTextProps {
	text: string;
	className?: string;
	valueClassName?: string;
	copiedText?: string;
	copiedTextClassName?: string;
}

const CopyText = ({
	text,
	className = '',
	valueClassName = '',
	copiedText = 'Copied!',
	copiedTextClassName = 'copied-text',
}: CopyTextProps) => {
	const [copied, setCopied] = useState(false);

	const copyToClipboard = (textToCopy: string) => {
		navigator.clipboard.writeText(textToCopy);
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 2000);
	};

	return (
		<div className={`copy-text-wrapper ${className}`}>
			<div className="copy-text-container">
				<span className={`copy-text-value ${valueClassName}`}>{text}</span>
				<WrappedButton
					buttonType={WrappedButtonType.TertiaryWhite}
					onClick={() => copyToClipboard(text)}
					aria-label="Copy to clipboard"
					additionalIconClassName="copy-icon"
					dataqa="copy-text-button"
				/>
			</div>
			{copied && <span className={copiedTextClassName}>{copiedText}</span>}
		</div>
	);
};

export default CopyText;
